































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Checkbox, CheckboxGroup, Button, Icon, Dialog, Toast } from "vant";
import { getBrowser } from "@/utils/browser";

const createAccountModule = namespace("createAccount"); 

@Component({
  name: "SignWrite",
  components: {
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component,
  }
})
export default class SignWrite extends Vue {
  @createAccountModule.Mutation("SAVE_SIGNATURE_PHOTO") saveSignaturePhoto: any;

  option = {
    // penColor: this.$store.getters["common/bgColor"] == 'black-theme' ? 'white' : "rgb(0, 0, 0)",
    backgroundColor: "transparent",
  };
  bgColor = this.$store.getters["common/bgColor"]
  showErrorDialog = false
  isAPP = false
  agreementResult: any = [];
  account_status = 0;     // 是否加开
  process_id = 1;
  isVertical = false;
  showDialog = false;
  closeDialogFlag = false;
  isEmpty = true;
  bg:any = require('@/assets/images/sign-pad-bg.png'); 

  mounted() {
    this.getCachedData();
    this.resize();
    window.addEventListener("resize", this.resize);
    const browser = getBrowser()
    this.isAPP = browser.isApp;
  }

  get isAccountStatusValid() {
    const invalidStatuses = [0, 2, 3, 21];
    return !invalidStatuses.includes(this.account_status);
  }

  async getCachedData() {
    try {
      const { account_status, process_info } = await (this as any).$apis.accountSituationV2({ step_code: '1,customer_confirmation,15' });
      this.account_status = account_status;
      const selectedProcessInfo = this.isAccountStatusValid ? 
                  process_info?.['customer_confirmation'] : 
                  process_info?.[15];
      if (selectedProcessInfo?.config_data) {
        const configData = JSON.parse(selectedProcessInfo.config_data || '{}');
        if (Array.isArray(configData.agreementResult) && configData.agreementResult.length > 0) {   // 检查解析后的数据是否为非空数组
          this.agreementResult = configData.agreementResult;
        } 
      }
      this.handleProcessId(process_info); 
      
    } catch (error) {
      
    }
  }
  handleProcessId(process_info) {
    // 加开就默认是4，首开从第一步取数据
    this.process_id = this.isAccountStatusValid
      ? 4 
      : process_info[1]?.process_id || 1;
  }
  getLang(){
	 let lang:any =  window.localStorage.getItem('localLang')
	 if(lang === 'zh-CN'){
		return this.bg = require('@/assets/images/sign-pad-bg.png'); 
	 }else if(lang === 'zh-HK'){
		return this.bg = require('@/assets/images/sign-pad-bg-hk.png'); 
	 }else{
		return this.bg = require('@/assets/images/sign-pad-bg-en.png');
	 }
	 
  }
  

  resize() {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const $html: any = document.querySelector("html");
    $html.style.height = height + "px";
    if (width >= height) {
      
      this.isVertical = false;
      this.showDialog = false;
    } else {
      // 竖屏
      this.isVertical = true;
      if (!this.closeDialogFlag) {
        // this.showDialog = true;
        this.showErrorDialog = true;
        
      }
    }
  }

  dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  

  getYearMonthDay() {
    const now = new Date(); // 创建一个表示当前日期和时间的 Date 对象

    const year = now.getFullYear(); // 获取四位数的年份
    const month = now.getMonth() + 1; // 获取月份（注意：月份是从 0 开始的，所以需要加 1）
    const day = now.getDate(); // 获取月份中的日期

    // 格式化月份和日期，确保它们是两位数
    const formattedMonth = month < 10 ? '0' + month : month;
    const formattedDay = day < 10 ? '0' + day : day;

    return {
        year,
        month: formattedMonth,
        day: formattedDay
    };
  }

  handleClearSignaturePhoto() {
    const signatureDom: any = this.isVertical
      ? this.$refs.signature
      : this.$refs.signatureWidth;
    signatureDom.clear();
  }

  async handleSaveSignaturePhoto() {
    const signatureDom: any = this.isVertical
      ? this.$refs.signature
      : this.$refs.signatureWidth;
    if (signatureDom.isEmpty()) {
      if (this.isVertical) {
        return Toast({
          ["message" as any]: this.$t(
            "open_account.sign_write.empty_toast_text"
          ),
          className: "vertical-toast"
        });
      } else {
        return Toast({
          ["message" as any]: this.$t(
            "open_account.sign_write.empty_toast_text"
          )
        });
      }
    }
    const png = signatureDom.save();
    this.saveSignaturePhoto(png);
    this.reportData(png);
  }
  reportData(png) {
    const { year, month, day } = this.getYearMonthDay();
    const query: any = { 
      process_id: this.process_id, step_code: 15, step_order: 15, 
      config_data: { 
        agreementResult: this.agreementResult,
        signImage: png,
        autograph_date: `${year}-${month}-${day}`
      },
      showLoading: true
    };
    // 加开的情况下修改key
    if ( this.isAccountStatusValid ) {
      query.step_code = 'customer_confirmation';
      query.step_order = 6;
    }
    (this as any).$apis.supplementSaveApi(query).then( res => {
      this.$router.back();
    })
  }
}
